import React, {Component, Fragment} from 'react';
import IManageCaseFolderSettingsForm from "./IManageCaseFolderSettingsForm";
import useDataApi from "utils/useDataApi";
import Notification, {notify} from 'common/Notification';
import { FORM_ERROR } from 'react-final-form';
import request from "superagent";

const onSave = (connectionId, casefolderId, settings) => {
  const {folder, workspace} = settings;

  return request.post(`/rpc/integrations/connections/${connectionId}/imanage/casefolders/${casefolderId}`)
    .send({ folder, workspace })
    .then(
      res => {
        notify.success('iManage Settings Saved');
      },
      error => {
        notify.error('Failed to save iManage settings');
        return {[FORM_ERROR]: 'Error Saving'};
      }
    );
};

export default function ({connection_id: connectionId, casefolder_id: casefolderId}) {
  const [{data}] = useDataApi(
    `/rpc/integrations/connections/${connectionId}/imanage/casefolders/${casefolderId}`,
    {}
  );

  return (
    <Fragment>
      <Notification/>
      <IManageCaseFolderSettingsForm
        onSave={settings => onSave(connectionId, casefolderId, settings)}
        connectionId={connectionId}
        casefolderId={casefolderId}
        settings={data}
      />
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/iManage/IManageCaseFolderSettings.jsx